export default __webpack_public_path__ + "static/media/Mobile_About_Us@1x.ca8a8de9.png";